// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider-theme.css
// module id = 416
// module chunks = 1